import { ReactNode } from 'react';

interface AsWrittenProps {
  /** Eyebrow heading inside the dashed box (e.g. "As written on the object"). */
  heading: ReactNode;
  /** Optional secondary hint rendered next to the heading. */
  hint?: ReactNode;
  children: ReactNode;
}

/**
 * Subdued left‑bordered dashed box matching the design's `.as-written`
 * pattern. Always rendered (no toggle) — the Hi‑Fi shows this box always
 * visible for Title / Signature / Creation Date.
 */
export const AsWritten = ({ heading, hint, children }: AsWrittenProps) => (
  <div className="as-written">
    <div className="aw-label">
      {heading}
      {hint && <span className="hint">{hint}</span>}
    </div>
    {children}
  </div>
);
